import React, { useState , useEffect} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import axios from "axios";

const SidebarAdmin = () => {
  const [isActive, setIsActive] = useState(false);
  const location = useLocation(); // Get current location

  const token = sessionStorage.getItem("Transport Admin AuthToken");
  
  const toggleSidebar = () => setIsActive(!isActive);
  const closeSidebar = () => setIsActive(false);
const navigate=useNavigate();
const setviewbyadmin =()=>{
if (location.pathname==="/Logistics/AdminPortal/Active"){

}
}
  const isActiveLink = (path) => location.pathname === path;
  const handlelogout =()=>{
    localStorage.removeItem('TransportData');
    localStorage.removeItem('Transport Admin AuthToken');
    navigate("/Logistics/Admin")
    
  }

  const [jobIds, setJobIds] = useState([]);
const [records, setRecords] = useState(0);

useEffect(() => {
  const fetchRecords = async () => {
    try {
      const response = await axios.get("https://zoomautos.co.uk/api/Subcontract", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { _t: new Date().getTime() }, // Bypass cache
      });

      const filteredData = response.data.filter(
        (item) => item.status === "Active" && item.viewbyadmin === false
      );

      const jobIdsList = filteredData.map((item) => item.jobId);
      setRecords(filteredData.length);
      setJobIds(jobIdsList);

      // Update `viewbyadmin` if on Active Jobs page
      if (location.pathname === "/Logistics/AdminPortal/Active" && jobIdsList.length > 0) {
        await Promise.all(
          jobIdsList.map(async (jobId) => {
            try {
              await axios.patch(
                `https://zoomautos.co.uk/api/Subcontract/${jobId}`,
                { viewbyadmin: true }, // Data payload
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
            } catch (error) {
              console.error(`Error updating job ${jobId}:`, error);
            }
          })
        );

        // After successful updates, reset count and jobIds
        setRecords(0);
        setJobIds([]);
      }
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  fetchRecords();
}, [location.pathname]); // Depend on pathname and token


  return (
    <div>
      {/* Top Navbar */}
      <nav className="top-navbar">
        <button className="sidenav-toggle" onClick={toggleSidebar}>
          &#9776; {/* Hamburger Icon */}
        </button>
        <div className="navbar-actions">
          <button className="login-btn" onClick={handlelogout}>LogOut</button>
        </div>
      </nav>

      {/* Sidebar */}
      <div className={`sidenav ${isActive ? "active" : ""}`}>
        {/* Logo */}
        <div className="sidenav-logo">
          <Link to="/">
            <img src="/Logo4.png" alt="Logo" />
            
          </Link>
        </div>

        {/* Close Button */}
        <button className="close-btn" onClick={closeSidebar}>
          &times;
        </button>

        {/* Navigation Links */}
        <ul>
          <li>
            <Link
              to="/Logistics/Admin/AdminPortal"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/Admin/AdminPortal") ? "active-link" : ""}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Pending"
              onClick={closeSidebar}
              className={
                isActiveLink("/Logistics/AdminPortal/Pending") ? "active-link" : ""
              }
            >
              Pending Jobs
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Active"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Active") ? "active-link" : ""}
            >
             Active Jobs 
            {records>0&&(
             <span className="quote-count">{records}</span>
            )} 
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Completed"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Completed") ? "active-link" : ""}
            >
              Completed Jobs
            </Link>
          </li>

          
          <li>
            <Link
              to="/Logistics/AdminPortal/RegisteredCustomers"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/RegisteredCustomers") ? "active-link" : ""}
            >
              Registered Clients
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Customers"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Customers") ? "active-link" : ""}
            >
              Customer Jobs
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Logos"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Logos") ? "active-link" : ""}
            >
              Logos
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Roles"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Roles") ? "active-link" : ""}
            >
              Roles
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Responsibilities"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Responsibilities") ? "active-link" : ""}
            >
              Responsibilites
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Time"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Time") ? "active-link" : ""}
            >
              Time
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/WhatWedo"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/WhatWedo") ? "active-link" : ""}
            >
              What We do
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/DriverEmail"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/DriverEmail") ? "active-link" : ""}
            >
              Driver
            </Link>
            </li>
          <li>
            
            <Link
              to="/Logistics/AdminPortal/Feedback"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Feedback") ? "active-link" : ""}
            >
              Feedback
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Services"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Services") ? "active-link" : ""}
            >
              Services
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Email"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Email") ? "active-link" : ""}
            >
              Email
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Location"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Location") ? "active-link" : ""}
            >
              Location
            </Link>
          </li>
          <li>
            <Link
              to="/Logistics/AdminPortal/Contact"
              onClick={closeSidebar}
              className={isActiveLink("/Logistics/AdminPortal/Contact") ? "active-link" : ""}
            >
              Contact
            </Link>
          </li>
          
          
        </ul>
      </div>
    </div>
  );
};

export default SidebarAdmin;
